export function isPromiseFulfilledResult(result) {
    return result.status === 'fulfilled';
}
export function isPromiseRejectedResult(result) {
    return result.status === 'rejected';
}
//# sourceMappingURL=PromiseUtil.js.map